"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
exports.default = vue_1.default.extend({
    data() {
        return {
            borderImageUrl: 'url(images/game/common/img_dialog_frame.png)',
        };
    },
    methods: {
        closeModal() {
            this.$store.commit('showComponent', {
                component: 'menuWindow',
                isShow: false,
            });
        },
        handleTermOfService() {
            // Check user device and open the warau’s termOfServices in new tab.
            if (navigator.userAgent.includes('Mobi')) {
                window.open('https://www.warau.jp/sp/info/userpolicy/');
                return;
            }
            window.open('https://www.warau.jp/service/guide/rule.html');
        },
        showComponent(component) {
            this.$store.commit('showComponent', {
                component: component,
                isShow: true,
            });
        },
    },
});
